<template>
  <div :id="id">
    <ul class="rank-bar">
      <li :key="index" :style="{ marginBottom: marginBottom }" v-for="(item, index) in lineData">
        <div :style="{
            background:
              index < color.length ? color[index] : color[color.length - 1]
          }" class="rank rank-bar-rank">
          <div>{{ index + 1 }}</div>
        </div>
        <div :style="{ width: nameMaxWidth + 'px' }" class="name rank-bar-name">{{ item.name }}</div>
        <div :class="['bar', { rect: rect }]" :style="{ width: barWidth + 'px' }">
          <div :class="['bar-in', { rect: rect }, 'bar' + index]" :id="rd + 'bar' + index" :style="{
              background:
                index < color.length ? color[index] : color[color.length - 1]
            }"></div>
        </div>
        <div class="num rank-bar-num">
          {{
          proportion ? Math.round((item.num / total) * 100) + "%" : item.num
          }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RankBar',
  props: {
    id: {
      type: String,
      default: 'rankBar'
    },
    chartData: {
      type: Array
    },
    color: {
      type: Array,
      default() {
        return ['#0080ff', '#00cdff', '#00d8ae', '#a1e058', '#ffe05f']
      }
    },
    rect: {
      type: String,
      default: ''
    },
    proportion: {
      type: String,
      default: ''
    },
    lineNum: {
      type: Number,
      default: 5
    },
    marginBottom: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rd: Math.round(Math.random() * 100000),
      nameMaxWidth: '',
      barWidth: ''
    }
  },
  computed: {
    lineData() {
      return this.chartData.slice(0, this.lineNum)
    },
    total() {
      var count = 0
      for (let i = 0; i < this.chartData.length; i++) {
        count += parseInt(this.chartData[i].num)
      }
      return count
    }
  },
  mounted() {
    if (this.chartData.length > 0) {
      this.initChart()
    }
  },
  methods: {
    initChart() {
      // 获得容器
      let box = document.getElementById(this.id)
      setTimeout(() => {
        // 获得容器总宽度
        let boxWidth = box.offsetWidth
        // 获得名字最长的宽度
        let nameWidthArr = []
        let nameDomArr = box.getElementsByClassName('rank-bar-name')
        for (let i = 0; i < nameDomArr.length; i++) {
          nameWidthArr.push(nameDomArr[i].offsetWidth)
        }
        this.nameMaxWidth = Math.max.apply(Math, nameWidthArr) + 2

        // 获得角标宽度
        let rankWidth = box.getElementsByClassName('rank-bar-rank')[0]
          .offsetWidth

        // 获得数字最长的宽度
        let numMaxWidth = box.getElementsByClassName('rank-bar-num')[0]
          .offsetWidth

        // 算出bar的剩余宽度 要减去margin
        this.barWidth =
          boxWidth - this.nameMaxWidth - rankWidth - numMaxWidth - 30
      }, 100)
      setTimeout(() => {
        this.lineData.forEach((item, index) => {
          // document.getElementById(this.rd + 'bar' + index).style.width =
          //   (item.num / this.lineData[0].num) * 100 + '%'
          box.getElementsByClassName('bar' + index)[0].style.width =
            (item.num / this.lineData[0].num) * 100 + '%'
        })
      }, 500)
    }
  },
  watch: {
    chartData() {
      this.initChart()
    }
  }
}
</script>
<style scoped lang="less">
.rank-bar {
  width: 100%;
  height: 100%;
  font-size: 0.15rem;
}
.rank-bar li {
  width: 100%;
  height: 0.22rem;
  margin: 0 0 0.18rem;
}
.rank-bar li > div {
  float: left;
}
.rank-bar li .rank {
  width: 0.2rem;
  height: 0.2rem;
  border-radius: 50%;
  text-align: center;
}
.rank-bar li .rank > div {
  width: 0.16rem;
  height: 0.16rem;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 50%;
  margin: 0.02rem auto;
  line-height: 0.17rem;
}
.rank-bar li .name {
  margin: 0 8px;
  text-align: left;
}
.rank-bar li .bar {
  height: 0.12rem;
  background: #053062;
  border-radius: 0.1rem;
  margin-top: 0.05rem;
}
.rank-bar li .num {
  margin-left: 8px;
}
.rank-bar li .rect {
  border-radius: 0 !important;
}
.rank-bar li .bar .bar-in {
  transition: all 0.5s;
  width: 0%;
  height: 0.12rem;
  border-radius: 0.1rem;
}
@media screen and (max-height: 863px) {
  .rank-bar li {
    height: 0.18rem;
    margin: 0 0 0.12rem;
  }
}
</style>
